// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JewE","colBig":"styles_colBig__3PVZq","colSmall":"styles_colSmall__1ensr"};